// `vue-loading-overlay` é publicado só como UMD (`dist/index.js`, sem campo `module`/`exports`).
// O wrapper UMD esconde os named exports do lexer de CJS do Vite, então o prebundle sai como
// `export default require_dist()` — ou seja, o default import entrega o **namespace** do módulo
// (`{ Component, LoadingPlugin, default, useLoading }`), não o componente. Vue então avisa
// "Component is missing template or render function" em toda tela que renderiza `<loading>`.
//
// Normalizar aqui, num lugar só, e importar SEMPRE deste módulo — nunca de 'vue-loading-overlay'
// direto. É o mesmo tratamento que `main.js` dá ao `vue3-draggable`, que tem o mesmo formato UMD.
//
// A cadeia cobre as três formas possíveis de interop: named export (`Component`), default do
// namespace CJS (`default`) e o caso em que o bundler já resolveu o default por conta própria.
import LoadingOverlay from 'vue-loading-overlay'

export default LoadingOverlay?.Component ?? LoadingOverlay?.default ?? LoadingOverlay
